import type React from 'react';
import SvgIcon from './SvgIcon';

const EnvelopeArrowRight: React.FC = () => (
  <SvgIcon
    width="22"
    height="20"
    viewBox="0 0 22 20"
    fill="none"
  >
    <g id="EnvelopeArrowRight">
      <path d="M21.207 13.793C21.3946 13.9805 21.5 14.2348 21.5 14.5C21.5 14.7321 21.4193 14.9558 21.2734 15.1338L21.207 15.207L16.707 19.707L15.293 18.293L18.0859 15.5H8V13.5H18.0859L15.293 10.707L16.707 9.29297L21.207 13.793Z" fill="currentColor" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 0.5C19.5523 0.5 20 0.947715 20 1.5V8H18V4.04395L10.6143 9.78906C10.2531 10.0699 9.74685 10.0699 9.38574 9.78906L2 4.04395V13.5H6V15.5H1C0.447715 15.5 0 15.0523 0 14.5V1.5C0 0.947715 0.447715 0.5 1 0.5H19ZM10 7.73242L16.7285 2.5H3.27148L10 7.73242Z"
        fill="currentColor" />
    </g>
  </SvgIcon>
);

export default EnvelopeArrowRight;
